module.exports = __webpack_public_path__ + "img/EFICIENCIA.1a786fc8.svg";